import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Langkawi escape early and enjoy the added luxury of a complimentary round-trip ferry transfer from Kuala Kedah to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-9824">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-9825">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-9826">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-9827" />
          <span data-id="element-9828">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-9829">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-9830">
          <div className="flex justify-between items-center" data-id="element-9831">
            <h2 className="text-xl font-bold" data-id="element-9832">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-9833">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-9834">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-9835">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-9836">
          <div className="p-6 border-r border-gray-200" data-id="element-9837">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9838">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9839">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9840">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-9841">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9842">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9843">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9844">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9845">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9846">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9847">
            <div data-id="element-9848">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9849">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9850">{reservation.booking.id}</p>
            </div>
            <div data-id="element-9851">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9852">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9853">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9854">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9855">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9856">
            <div data-id="element-9857">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9858">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9859">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-9860">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9861">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9862">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9863">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9864">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9865">
            <div data-id="element-9866">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9867">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9868">{reservation.room.name}</p>
            </div>
            <div data-id="element-9869">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9870">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9871">{reservation.room.view}</p>
            </div>
            <div data-id="element-9872">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9873">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9874">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9875">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9876">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-9877">
            <h4 className="text-base font-medium mb-4" data-id="element-9878">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9879">
              <div data-id="element-9880">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9881">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9882">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-9883">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9884">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9885">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-9886">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9887">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9888">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-9889">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9890">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9891">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-9892">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9893">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9894">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-9895">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9896">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9897">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-9898">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9899">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-9900">
            <div data-id="element-9901">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9902">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9903">{reservation.rate.name}</p>
            </div>
            <div data-id="element-9904">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9905">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9906">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-9907">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9908">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-9909">
            <div className="flex justify-between" data-id="element-9910">
              <p className="text-sm text-gray-500" data-id="element-9911">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9912">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-9913">
              <p className="text-sm text-gray-500" data-id="element-9914">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9915">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-9916">
              <p className="text-sm font-medium" data-id="element-9917">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-9918">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}